import _ from 'lodash'
import { fromJS, isImmutable, List, Map } from 'immutable'
import { getParams, getState } from './processPortalRules'
import { getMappingCount } from '../constants/getMappingCount'
import { trimKeySuffix } from './KeySuffixRe'
import { getElementDataRoot } from '../constants/getElementDataRoot'
import { getParentIdInModal, getValueForMode } from '../constants/toUnits'
import moment from 'moment'
import { getFormDateFormat } from './format'

export const compactArrayPath = (path) => _.uniqBy(path, (val) => _.join(val, ''))

const updateState = (state, path, value) => {
  if (path && _.isArray(path) && path[0] == 'params') {
    return state.setIn(path, fromJS(value))
  } else {
    return state.setIn(['state'], fromJS(_.set(state.getIn(['state'], Map()).toJS(), path, value)))
  }
}

const getPowerFields = (fields) =>
  fields.filter((field) => ['numeric', 'string', 'customJS'].indexOf(field.get('paramType')) > -1)

const calculateStringParameter = (field, appState, state, repeatIndex) => {
  let strHtmlVal = String(_.get(field, 'customField.expression', ''))
  let strVal = String(_.get(field, 'customField.expression_text', ''))
  const repeatStrips = getPageRepeatStrips(state)
  _.each(_.get(field, 'customField.uids', {}), (v, k) => {
    try {
      const path = String(_.last(String(k).split('#-#'))).split(':')
      const [pageUID, prID, rID] = path
      const pageID = state
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('uid') === pageUID)
        ?.get?.('_id')
      if (String(k).indexOf(':ftStripRow') > -1) {
        let val = repeatIndex
        if (typeof repeatIndex == 'number') {
          val++
        } else {
          val = ''
        }
        strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), val)
        return true
      } else if (pageID) {
        let elem = state.getIn([...getElementDataRoot(pageID), 'elements', String(rID).replace('-formattedValue', '')])
        if (!elem) {
          elem = state.hasIn([...getElementDataRoot(pageID), 'elements', String(rID).replace('-formattedValue', '')])
            ? state.getIn([...getElementDataRoot(pageID), 'elements', String(rID).replace('-formattedValue', '')])
            : state.getIn([...getElementDataRoot(pageID), 'elements', String(prID).replace('-formattedValue', '')])
        }
        if (
          elem &&
          isImmutable(elem) &&
          elem.get('type') === 'FormField' &&
          ['date', 'time', 'datetime'].includes(elem.getIn(['props', 'control'], 'text'))
        ) {
          if (_.endsWith(rID, '-formattedValue') || _.endsWith(prID, '-formattedValue')) {
            const value = _.get(appState, path, '')
            strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), value)
          } else {
            const fieldProps = getValueForMode(elem, state.get('layoutMode', 'lg'), ['props'], [], Map()).toJS()
            let format = getFormDateFormat(fieldProps, elem.getIn(['props', 'control'], 'text'))
            const value = _.get(appState, path, '')
            let momentValue = ''
            if (value) {
              if (elem.getIn(['props', 'control']) === 'time') {
                momentValue = moment(moment().format('YYYY-MM-DD') + ' ' + value)
                  .utc()
                  .format(format)
              } else {
                momentValue = moment(value).format(format)
              }
            }
            momentValue = momentValue === 'Invalid date' ? '' : momentValue
            strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), momentValue)
          }
        }
      }
      let value = _.get(appState, path, '')
      try {
        const isLastLookupPath = ['ft_value', 'ft_text'].includes(_.last(path)) && repeatStrips.includes(path[1])
        if (
          repeatStrips.includes(path[1]) &&
          (path.includes('ftListValue') || path.includes('ftListLabel')) &&
          repeatIndex !== null &&
          repeatIndex !== undefined
        ) {
          value = _.get(appState, [..._.initial(path), repeatIndex, _.last(path)])
          if (value === undefined) {
            value = _.get(appState, [..._.initial(path), _.last(path), repeatIndex], '')
          }
        } else if (
          repeatStrips.includes(path[1]) &&
          (path.includes('ftListValue') || path.includes('ftListLabel')) &&
          (repeatIndex === null || repeatIndex === undefined)
        ) {
          let size = getMappingCount(_.get(appState, [path[0], path[1]], {}))
          value = []
          _.times(size, (n) => {
            let val = _.get(appState, [..._.initial(path), n, _.last(path)])
            if (val === undefined) {
              val = _.get(appState, [..._.initial(path), _.last(path), n], '')
            }
            value.push(val)
          })
          value = _.compact(value).join(',')
        } else if (
          repeatStrips.includes(path[1]) &&
          isLastLookupPath &&
          repeatIndex !== null &&
          repeatIndex !== undefined
        ) {
          value = _.get(appState, [..._.initial(path), repeatIndex, _.last(path)], '')
        } else if (
          repeatStrips.includes(path[1]) &&
          isLastLookupPath &&
          (repeatIndex === null || repeatIndex === undefined)
        ) {
          let size = getMappingCount(_.get(appState, [path[0], path[1]], {}))
          value = []
          _.times(size, (n) => {
            value.push(_.get(appState, [..._.initial(path), n, _.last(path)], ''))
          })
          value = _.compact(value).join(',')
        }
      } catch (error) {
        console.log(error)
      }
      try {
        const isLastCustomPath = ['startDate', 'endDate'].includes(_.last(path))
        if (repeatStrips.includes(path[1]) && isLastCustomPath && repeatIndex !== null && repeatIndex !== undefined) {
          value = _.get(appState, [..._.initial(path), repeatIndex, _.last(path)], '')
        } else if (
          repeatStrips.includes(path[1]) &&
          isLastCustomPath &&
          (repeatIndex === null || repeatIndex === undefined)
        ) {
          let size = getMappingCount(_.get(appState, [path[0], path[1]], {}))
          value = []
          _.times(size, (n) => {
            value.push(_.get(appState, [..._.initial(path), n, _.last(path)], ''))
          })
          value = _.compact(value).join(',')
        }
      } catch (error) {
        console.error(error)
      }
      if (_.isPlainObject(value)) {
        strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), _.values(value).join(', '))
      } else {
        strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), value)
      }
    } catch (error) {
      console.error(error)
    }
  })
  return strVal
}

const calculateNumericParameter = (field, appState, param, repeatIndex) => {
  let strVal = String(_.get(field, 'customField.expression_text', '')).replace(/\n|\r/g, '')
  _.each(_.get(field, 'customField.uids', {}), (v, k) => {
    try {
      const path = String(_.last(String(k).split('#-#'))).split(':')
      let value = _.get(appState, path, 0)
      if (String(k).indexOf(':ftStripRow') > -1) {
        if (typeof repeatIndex == 'number') {
          value = repeatIndex + 1
        } else {
          value = 0
        }
        strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), value)
      } else if (_.isArray(value) || _.isPlainObject(value)) {
        let total = 0
        _.each(_.isArray(value) ? value : _.values(value), function (val) {
          val = parseFloat(String(val).replace(/,/g, '.'))
          if (!_.isNaN(val)) {
            total += val
          }
        })
        strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), total)
      } else {
        if (value === '') {
          value = 0
        }
        if (typeof value === 'string') {
          value = parseFloat(String(value).replace(/,/g, '.'))
          if (isNaN(value)) {
            value = 0
          }
        }
        strVal = strVal.replace(new RegExp(`{${k}}`, 'g'), String(value).replace(/,/g, '.'))
      }
    } catch (error) {
      console.error(error)
    }
  })

  try {
    let instr = `(() => {
            return ${strVal}
        })()`
    return eval(instr)
  } catch (error) {
    console.error(error)
    return ''
  }
}

const calculateCustomJSParameter = (field, appState, state, repeatIndex) => {
  const repeatStrips = getPageRepeatStrips(state)
  let strVal = String(_.get(field, 'customField.expression_text', ''))
  let staticValues = []
  _.each(_.get(field, 'customField.uids', {}), (v, k) => {
    const kOrigin = String(k)
    k = _.trim(k, '{}')
    const path = String(String(k).includes('#-#') ? _.last(String(k).split('#-#')) : k).split(':')
    let value = _.get(appState, path, '')
    if (String(k).indexOf(':ftStripRow') > -1) {
      if (typeof repeatIndex == 'number') {
        value = repeatIndex + 1
      } else {
        value = 0
      }
    }
    try {
      const isLastLookupPath = ['ft_value', 'ft_text'].includes(_.last(path))
      if (repeatStrips.includes(path[1]) && isLastLookupPath && repeatIndex !== null && repeatIndex !== undefined) {
        value = _.get(appState, [..._.initial(path), repeatIndex, _.last(path)], '')
      } else if (
        repeatStrips.includes(path[1]) &&
        isLastLookupPath &&
        (repeatIndex === null || repeatIndex === undefined)
      ) {
        let size = getMappingCount(_.get(appState, [path[0], path[1]], {}))
        value = []
        _.times(size, (n) => {
          value.push(_.get(appState, [..._.initial(path), n, _.last(path)], ''))
        })
        value = _.compact(value).join(',')
      }
    } catch (error) {
      console.error(error)
    }
    try {
      const isLastCustomPath = ['ftListValue', 'ftListLabel'].includes(_.last(path))
      if (repeatStrips.includes(path[1]) && isLastCustomPath && repeatIndex !== null && repeatIndex !== undefined) {
        value = _.get(
          appState,
          [..._.initial(path), repeatIndex, _.last(path)],
          _.get(appState, [..._.initial(path), _.last(path), repeatIndex], '')
        )
      } else if (
        repeatStrips.includes(path[1]) &&
        isLastCustomPath &&
        (repeatIndex === null || repeatIndex === undefined)
      ) {
        let size = getMappingCount(_.get(appState, [path[0], path[1]], {}))
        value = []
        _.times(size, (n) => {
          value.push(
            _.get(
              appState,
              [..._.initial(path), n, _.last(path)],
              _.get(appState, [..._.initial(path), _.last(path), n], '')
            )
          )
        })
        value = _.compact(value).join(',')
      }
    } catch (error) {
      console.error(error)
    }
    try {
      const isLastCustomPath = ['startDate', 'endDate'].includes(_.last(path))
      if (repeatStrips.includes(path[1]) && isLastCustomPath && repeatIndex !== null && repeatIndex !== undefined) {
        value = _.get(appState, [..._.initial(path), repeatIndex, _.last(path)], '')
      } else if (
        repeatStrips.includes(path[1]) &&
        isLastCustomPath &&
        (repeatIndex === null || repeatIndex === undefined)
      ) {
        let size = getMappingCount(_.get(appState, [path[0], path[1]], {}))
        value = []
        _.times(size, (n) => {
          value.push(_.get(appState, [..._.initial(path), n, _.last(path)], ''))
        })
        value = _.compact(value).join(',')
      }
    } catch (error) {
      console.error(error)
    }
    if (strVal.includes("'{{")) {
      strVal = strVal
        .replace(new RegExp(`'{{${kOrigin}}}'`, 'g'), `val[${staticValues.length}]`)
        .replace(new RegExp(`'{{${k}}}'`, 'g'), `val[${staticValues.length}]`)
    } else {
      strVal = strVal
        .replace(new RegExp(`{${kOrigin}}`, 'g'), `val[${staticValues.length}]`)
        .replace(new RegExp(`{${k}}`, 'g'), `val[${staticValues.length}]`)
    }
    staticValues.push(value)
  })
  window.ftGetLocalIndex = repeatIndex
  window.ftGetLocalState = () => {
    return state
  }
  try {
    const func = eval(`(function(val, _){${strVal}})`)
    let result
    if (typeof func === 'function') {
      result = func(staticValues, _)
    } else {
      result = ''
    }
    window.ftGetLocalState = null
    window.ftGetLocalIndex = null
    return result
  } catch (error) {
    window.ftGetLocalState = null
    window.ftGetLocalIndex = null
    console.error(error)
    return ''
  } finally {
    window.ftGetLocalState = null
    window.ftGetLocalIndex = null
  }
}

const getPageRepeatStrips = (state) => {
  let list = state
    .getIn(['pages', state.get('page'), 'Props', 'elements'], Map())
    .filter((el) => {
      if (el.get('type') === 'Strip') {
        return (
          el.getIn(['props', 'isRepeat'], false) ||
          (el.getIn(['props', 'isRepeatCol'], false) && Boolean(el.getIn(['props', 'repeatColName'])))
        )
      } else if (el.get('type') === 'RepeatAutoFit') {
        return true
      } else {
        return false
      }
    })
    .reduce((r, v, k) => r.push(k), List())
    .toJS()

  state.getIn(['project', 'Settings', 'elements'], Map()).map((el, id) => {
    if (
      (el.get('type') === 'Strip' && el.getIn(['props', 'isRepeat'], false)) ||
      (el.getIn(['props', 'isRepeatCol'], false) && Boolean(el.getIn(['props', 'repeatColName'])))
    ) {
      list.push(id)
    } else if (el.get('type') === 'RepeatAutoFit') {
      list.push(id)
    }
  })

  return list
}

const getRepeatStripParameters = (state) => (r, uid) => {
  const isProject = state.hasIn(['project', 'Settings', 'elements', uid, 'type'])
  const el = state.getIn([...getElementDataRoot(isProject ? 'project' : state.get('page')), 'elements', uid], Map())
  return {
    ...r,
    [uid]: el
      .getIn(['props', 'params'], List())
      .filter((field) => ['numeric', 'string', 'customJS'].indexOf(field.get('paramType')) > -1)
      .toJS(),
  }
}

const getElementParent = (state, uid, pageUID) => {
  const isProject = state.hasIn(['project', 'Settings', 'elements', uid, 'type'])
  const parent = getParentIdInModal(state, uid, isProject)
  if (isProject) {
    return parent
  } else {
    return pageUID
  }
}

const processFieldEntry =
  (isPage = false, pageUID, appState, returnState, changesPath, state) =>
  (field) => {
    const path = isPage ? [pageUID, ...String(field.id).split(':')] : [field.id]
    const statePath = isPage ? [pageUID, ...String(field.id).split(':')] : ['params', field.id]
    switch (field.valueType) {
      case 'string': {
        const value = calculateStringParameter(field, appState, state)
        appState = _.set(appState, path, value)
        returnState = updateState(returnState, statePath, value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push(path)
        break
      }
      case 'numeric': {
        const value = calculateNumericParameter(field, appState, state)
        appState = _.set(appState, path, value)
        returnState = updateState(returnState, statePath, value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push(path)
        break
      }
      case 'customJS': {
        const value = calculateCustomJSParameter(field, appState, state)
        appState = _.set(appState, path, value)
        returnState = updateState(returnState, statePath, value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push(path)
        break
      }
    }

    return returnState
  }

export const initializePowerFields = (state) => {
  const pagePowerFields = getPowerFields(state.getIn(['pages', state.get('page'), 'Props', 'params'], List())).toJS()
  const projectPowerFields = getPowerFields(state.getIn(['project', 'params'], List())).toJS()

  const pageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === state.get('page'))
    ?.get?.('uid')

  let returnState = state

  const appState = _.assign({}, getState(state), getParams(state))

  let changesPath = []

  _.each(projectPowerFields, (field) => {
    switch (field.valueType) {
      case 'string': {
        const value = calculateStringParameter(field, appState, state)
        _.set(appState, [field.id], value)
        returnState = returnState.setIn(['params', field.id], value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param:') || _.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push([field.id])
        break
      }
      case 'numeric': {
        const value = calculateNumericParameter(field, appState, state)
        _.set(appState, [field.id], value)
        returnState = returnState.setIn(['params', field.id], value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param:') || _.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push([field.id])
        break
      }
      case 'customJS': {
        const value = calculateCustomJSParameter(field, appState, state)
        _.set(appState, [field.id], value)
        returnState = returnState.setIn(['params', field.id], value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param:') || _.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push([field.id])
        break
      }
    }
  })

  _.each(pagePowerFields, (field) => {
    switch (field.valueType) {
      case 'string': {
        const value = calculateStringParameter(field, appState, state)
        const paramPath = String(field.id).split(':')
        _.set(appState, [pageUID, ...paramPath], value)
        returnState = updateState(returnState, [pageUID, ...paramPath], value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param:') || _.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push([pageUID, ...paramPath])
        break
      }
      case 'numeric': {
        const value = calculateNumericParameter(field, appState, state)
        const paramPath = String(field.id).split(':')
        _.set(appState, [pageUID, ...paramPath], value)
        returnState = updateState(returnState, [pageUID, ...paramPath], value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param:') || _.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push([pageUID, ...paramPath])
        break
      }
      case 'customJS': {
        const value = calculateCustomJSParameter(field, appState, state)
        const paramPath = String(field.id).split(':')
        _.set(appState, [pageUID, ...paramPath], value)
        returnState = updateState(returnState, [pageUID, ...paramPath], value)
        _.each(_.get(field, 'customField.settings.mapResultTo', []), (key) => {
          if (_.startsWith(key, 'param:') || _.startsWith(key, 'param#-#')) {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = returnState.setIn(['params', ...path], value)
            changesPath.push(path)
          } else {
            const path = String(_.last(String(key).split('#-#'))).split(':')
            returnState = updateState(returnState, path, value)
            changesPath.push(path)
          }
        })
        changesPath.push([pageUID, ...paramPath])
        break
      }
    }
  })
  changesPath = compactArrayPath(changesPath)
  return [returnState, changesPath]
}

export const recalculatePowerFields = (state, changePath, allChangesProvided) => {
  if (_.size(changePath) === 0 && _.size(allChangesProvided) === 0) {
    //no changes nothing recalculate
    return [state, []]
  }
  let data
  // console.time('recalculatePowerFields')
  data = _recalculatePowerFields(state, compactArrayPath(changePath), compactArrayPath(allChangesProvided))
  // console.timeEnd('recalculatePowerFields')
  return data
}
const _recalculatePowerFields = (state, changePath, allChangesProvided) => {
  const formatFormulaKey = (localPath) => {
    let resultPath = localPath
    if (typeof _.last(localPath) === 'number') {
      resultPath = _.initial(localPath)
    } else {
      resultPath = localPath
    }
    if (_.last(resultPath) == 'value') {
      resultPath = _.initial(localPath)
    }
    if (['ft_value', 'ft_text'].includes(_.last(resultPath))) {
      resultPath = _.initial(localPath)
    }
    return resultPath.join(':')
  }

  const elementsPath = _.reduce(changePath, (r, v) => [...r, formatFormulaKey(v)], [])

  if (!allChangesProvided) {
    allChangesProvided = []
  }
  let allChanges = [...allChangesProvided, ...changePath]
  let prevAllChanges = {}
  _.each(allChanges, (val) => {
    prevAllChanges[_.join(val, '')] = true
  })
  const pagePowerFields = getPowerFields(state.getIn(['pages', state.get('page'), 'Props', 'params'], List()))
    .filter((field) => {
      const dep = _.keys(field.getIn(['customField', 'uids'], Map()).toJS())
      let isFind = false
      _.each(dep, (key) => {
        let elKey = _.last(String(key).split('#-#'))
        let exElKey = trimKeySuffix(elKey).replace('-formattedValue', '')
        exElKey = formatFormulaKey(String(exElKey).split(':'))
        if (elementsPath.indexOf(elKey) !== -1 || elementsPath.indexOf(exElKey) !== -1) {
          isFind = true
          return false
        }
      })
      return isFind
    })
    .toJS()

  const projectPowerFields = getPowerFields(state.getIn(['project', 'params'], List()))
    .filter((field) => {
      const dep = _.keys(field.getIn(['customField', 'uids'], Map()).toJS())
      let isFind = false
      _.each(dep, (key) => {
        key = formatFormulaKey(String(key).split(':'))
        let fieldKey = _.last(String(key).split('#-#'))
        fieldKey = String(fieldKey).replace('-formattedValue', '')
        if (elementsPath.indexOf(fieldKey) !== -1) {
          isFind = true
          return false
        } else {
          if (String(fieldKey).includes(':ftListValue')) {
            fieldKey = String(fieldKey).replace(':ftListValue', '')
            if (elementsPath.indexOf(fieldKey) !== -1) {
              isFind = true
              return false
            }
          }
        }
      })
      return isFind
    })
    .toJS()

  let repeatStrips = getPageRepeatStrips(state)
  const elementsStripHash = {}
  _.each(allChanges, (path) => {
    elementsStripHash[path[1]] = true
  })
  repeatStrips = _.filter(repeatStrips, (stripID) => elementsStripHash[stripID])
  const repeatStripParameters = _.reduce(repeatStrips, getRepeatStripParameters(state), {})

  const pageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === state.get('page'))
    ?.get?.('uid')

  let returnState = state

  let appState = _.assign({}, getState(state), getParams(state))

  let changesPath = []

  _.each(repeatStrips, (uid) => {
    const stripParams = repeatStripParameters[uid] || []
    const parent = getElementParent(state, uid, pageUID)

    const stripState = _.get(appState, [parent, uid], {})
    const rows = getMappingCount(stripState)
    _.times(rows, (row) => {
      _.each(stripParams, (field) => {
        if (!_.get(appState, [parent, uid, field.id])) {
          appState = _.set(appState, [parent, uid, field.id], [])
        }
        if (!returnState.getIn(['state', parent, uid, field.id])) {
          returnState = returnState.setIn(['state', parent, uid, field.id], List())
        }
        let fieldToProcess = JSON.parse(JSON.stringify(field))
        let patchUID = {}
        _.each(_.get(field, 'customField.uids', {}), (v, k) => {
          const key = String(_.last(String(_.trim(k, '{}')).split('#-#'))).split(':')
          const isLastLookupPath = [
            'ft_value',
            'ft_text',
            'ftListValue',
            'ftListLabel',
            'startDate',
            'endDate',
          ].includes(_.last(key))
          if (repeatStrips.indexOf(key[1]) !== -1 && !isLastLookupPath) {
            const key = _.trim(k, '{}')
            if (!_.endsWith(key, `:${row}`)) {
              _.set(
                fieldToProcess,
                'customField.expression_text',
                _.get(fieldToProcess, 'customField.expression_text', '')
                  .replace(new RegExp(`{${key}}`, 'g'), `{${key}:${row}}`)
                  .replace(new RegExp(`{{${key}}}`, 'g'), `{{${key}:${row}}}`)
              )
              patchUID[`${key}:${row}`] = true
            } else {
              patchUID[k] = true
            }
          } else {
            patchUID[k] = true
          }
        })
        _.set(fieldToProcess, ['customField', 'uids'], patchUID)

        switch (field.valueType) {
          case 'string': {
            const value = calculateStringParameter(fieldToProcess, appState, state, row)
            appState = _.set(appState, [parent, uid, field.id, row], value)
            returnState = returnState.setIn(['state', parent, uid, field.id, row], value)
            _.each(_.get(fieldToProcess, 'customField.settings.mapResultTo', []), (key) => {
              if (_.startsWith(key, 'param#-#')) {
                const path = String(_.last(String(key).split('#-#'))).split(':')
                returnState = returnState.setIn(['params', ...path], value)
                changesPath.push(path)
              } else {
                const path = String(_.last(String(key).split('#-#'))).split(':')
                if (repeatStrips.indexOf(path[1]) !== -1) {
                  returnState = updateState(returnState, [...path, row], value)
                  changesPath.push([...path, row])
                } else {
                  returnState = updateState(returnState, path, value)
                  changesPath.push(path)
                }
              }
            })
            changesPath.push([parent, uid, field.id, row])
            break
          }
          case 'numeric': {
            const value = calculateNumericParameter(fieldToProcess, appState, state, row)
            appState = _.set(appState, [parent, uid, field.id, row], value)
            returnState = returnState.setIn(['state', parent, uid, field.id, row], value)
            _.each(_.get(fieldToProcess, 'customField.settings.mapResultTo', []), (key) => {
              if (_.startsWith(key, 'param#-#')) {
                const path = String(_.last(String(key).split('#-#'))).split(':')
                returnState = returnState.setIn(['params', ...path], value)
                changesPath.push(path)
              } else {
                const path = String(_.last(String(key).split('#-#'))).split(':')
                if (repeatStrips.indexOf(path[1]) !== -1) {
                  returnState = updateState(returnState, [...path, row], value)
                  changesPath.push([...path, row])
                } else {
                  returnState = updateState(returnState, path, value)
                  changesPath.push(path)
                }
              }
            })
            changesPath.push([parent, uid, field.id, row])
            break
          }
          case 'customJS': {
            const value = calculateCustomJSParameter(fieldToProcess, appState, state, row)
            appState = _.set(appState, [parent, uid, field.id, row], value)
            returnState = returnState.setIn(['state', parent, uid, field.id, row], value)
            _.each(_.get(fieldToProcess, 'customField.settings.mapResultTo', []), (key) => {
              if (_.startsWith(key, 'param#-#')) {
                const path = String(_.last(String(key).split('#-#'))).split(':')
                returnState = returnState.setIn(['params', ...path], value)
                changesPath.push([path])
              } else {
                const path = String(_.last(String(key).split('#-#'))).split(':')
                if (repeatStrips.indexOf(path[1]) !== -1) {
                  returnState = updateState(returnState, [...path, row], value)
                  changesPath.push([...path, row])
                } else {
                  returnState = updateState(returnState, path, value)
                  changesPath.push(path)
                }
              }
            })
            changesPath.push([parent, uid, field.id, row])
            break
          }
        }
      })
    })
  })

  _.each(projectPowerFields, function (field) {
    returnState = processFieldEntry(false, pageUID, appState, returnState, changesPath, state)(field)
  })
  _.each(pagePowerFields, function (field) {
    returnState = processFieldEntry(true, pageUID, appState, returnState, changesPath, state)(field)
  })

  let hashAllChanges = {}
  _.each(allChanges, function (key) {
    if (key) {
      hashAllChanges[key.join(':')] = true
    }
  })

  let recountPowerFields = []
  _.each(changesPath, function (key) {
    if (key) {
      if (!hashAllChanges[key.join(':')]) {
        recountPowerFields.push(key)
      }
    }
  })
  recountPowerFields = _.uniqBy(recountPowerFields, (val) => _.join(val, ''))

  allChanges = [...allChanges, ...recountPowerFields]

  recountPowerFields = _.filter(recountPowerFields, (changePath) => !prevAllChanges[_.join(changePath, '')])

  if (recountPowerFields.length) {
    const [st, changes] = recalculatePowerFields(
      returnState,
      compactArrayPath(recountPowerFields),
      compactArrayPath(allChanges)
    )
    returnState = st
    changesPath.push(...changes)
    changesPath = compactArrayPath(changesPath)
  }
  return [returnState, changesPath]
}
